// api
import { fetchApi } from '@/api'
// actions
const schoolRoutesNewsAll = (context) => {
  let url = 'schoolroutes/news'
  let data = {}
  fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_NEWS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolRoutesNewsForm = (context) => {
  let url = 'schoolroutes/news/create'
  let data = {}
  fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_NEWS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolRoutesNewsShow = (context) => {
  let url = 'schoolroutes/news'
  let data = {}
  fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_NEWS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const schoolRoutesNewsCreate = (context) => {
  let url = 'schoolroutes/news/create'
  let data = {}
  fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('SCHOOLROUTES_NEWS_CREATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolRoutesNewsUpdate = (context) => {
  let url = 'schoolroutes/news'
  let data = {}
  fetchApi(url, data, 'PUT')
    .then((response) => {
      context.commit('SCHOOLROUTES_NEWS_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const schoolRoutesNewsDelete = (context, payload) => {
  let url = 'schoolroutes/news'
  console.log(payload)
  fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('SCHOOLROUTES_NEWS_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  schoolRoutesNewsAll,
  schoolRoutesNewsForm,
  schoolRoutesNewsShow,
  schoolRoutesNewsCreate,
  schoolRoutesNewsUpdate,
  schoolRoutesNewsDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/schoolroutes/news/actions.js